// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 🌐 Base Layout */
.ShareDeveloper_container__NX6tL {
  width: 100%;
  /* background-color: var(--white-color); */
  /* border-radius: 10px; */
  padding: 2rem;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
  height: 100%;
  /* min-height: 0; */
}
.ShareDeveloper_shareDevWrap__4RodI {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /* align-items: flex-start; */
}
.ShareDeveloper_title__ZMVnh {
  font-size: 1.8rem;
  font-weight: 600;
  margin-bottom: 1.5rem;
  color: var(--dark-color);
  text-align: center;
  letter-spacing: 0.5px;
}
.ShareDeveloper_leftSection__L1fTW {
  flex: 1 1 40%;
  min-width: 360px;
  background: #ffffffcc;
  backdrop-filter: blur(10px);
  border-radius: 6px 0px 0px 6px;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); */
  padding: 30px 40px;
  border: 1px solid #ccc;
  transition: all 0.3s ease;
  /* height: 100%; */
  border-right: 0px;
}

.ShareDeveloper_rightSection__JZZ1S {
  flex: 1 1 55%;
  min-width: 320px;
  background: linear-gradient(135deg, #eff6ff 0%, #e0f2fe 100%);
  border-radius: 0px 6px 6px 0px;
  padding: 30px;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); */
  /* height: 100%; */
  border: 1px solid #ccc;
  border-left: 2px dashed #a3a3fb;
}

h2 {
  margin-bottom: 20px;
  font-size: 1.8rem;
  font-weight: 600;
  color: #0f172a;
}

h3 {
  margin-bottom: 15px;
  font-size: 1.25rem;
  color: #1e293b;
}

.ShareDeveloper_appInfo__36n35 {
  background: #f1f5f9;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 25px;
  border-left: 5px solid #3b82f6;
}
.ShareDeveloper_appDetails__qgsWc {
  display: flex;
  align-items: flex-start;
  gap: 30px;
}
.ShareDeveloper_appDetailsContent__RVxpu {
  display: flex;
  align-items: center;
  gap: 4px;
}
.ShareDeveloper_appDetailsContent__RVxpu strong {
  font-weight: 500;
  color: #111827;
  margin-right: 4px;
  background-color: var(--white-color);
  border: 1px solid #2563eb;
  padding: 8px 12px;
  border-radius: 8px;
  max-width: 75%;
  word-wrap: break-word;
  font-size: 16px;
}
.ShareDeveloper_appDetailsContent__RVxpu p {
  color: #475569;
  text-align: left;
}

/* 📝 Form Styling */
.ShareDeveloper_form__hr6Gk {
  display: flex;
  flex-direction: column;
  /* gap: 18px; */
}

.ShareDeveloper_formGroup__p-dUP {
  margin-bottom: 24px;
  position: relative;
  text-align: left;
}

.ShareDeveloper_label__K-pUx {
  display: block;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #555;
}

.ShareDeveloper_requiredStar__VyZgF {
  color: red;
  font-weight: bold;
}

.ShareDeveloper_inputWrapper__i4RxL {
  position: relative;
  display: flex;
  align-items: center;
}

.ShareDeveloper_input__j0PCw {
  width: 100%;
  padding: 16px;
  font-weight: 600;
  border: none;
  background: var(--seconadry-ic-bg, #f9fafb);
  border-radius: 8px;
  color: var(--text-color, #111);
  padding-right: 50px;
  outline: none;
}

.ShareDeveloper_inputIcon__7Cj-H {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-color, #666);
  font-size: 24px;
}

.ShareDeveloper_input__j0PCw:focus {
  border-color: #3b82f6;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

/* ℹ️ Help & Message Boxes */
.ShareDeveloper_helpText__6oe\\+S {
  font-size: 12px;
  color: #64748b;
  margin-top: 10px;
}

.ShareDeveloper_messagePreview__NMXd9 {
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 15px;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  /* max-height: 280px; */
  overflow-y: auto;
  color: #334155;
  /* height: 93%; */
  text-align: left;
  border-left: 5px solid #3b82f6;
}

.ShareDeveloper_messageLine__aTxEE {
  margin-bottom: 18px;
}

.ShareDeveloper_highlightedText__U8gOT {
  color: #2563eb;
  font-weight: 600;
  background-color: #eff6ff;
  padding: 1px 4px;
  border-radius: 4px;
}

/* 🚀 Button */
.ShareDeveloper_button__OeutN {
  width: 100%;
  height: 58px;
  margin-top: 36px;
  background-color: var(--primary);
  color: var(--white-color);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
}

.ShareDeveloper_button__OeutN:hover:not(:disabled) {
  background: var(--primary-hover);
}

.ShareDeveloper_button__OeutN:disabled {
  background: #93c5fd;
  cursor: not-allowed;
}

/* ✅ Status Messages */
.ShareDeveloper_status__YvP0O {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: 500;
  text-align: center;
}

.ShareDeveloper_success__96eqK {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.ShareDeveloper_error__KBCVO {
  background: #fee2e2;
  color: #991b1b;
  border: 1px solid #fecaca;
}

/* 🖼️ Right Panel Preview */
.ShareDeveloper_preview__YePgf h3 {
  margin-top: 0;
  color: #0f172a;
  font-weight: 600;
}

.ShareDeveloper_previewList__yXXbp {
  list-style: none;
  padding: 0;
  margin: 0;
}

.ShareDeveloper_previewList__yXXbp li {
  padding: 8px 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #334155;
}

.ShareDeveloper_previewList__yXXbp li::before {
  content: "✔";
  margin-right: 8px;
  color: var(--primary);
}
.ShareDeveloper_formWarp__VvS4Z {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
}
.ShareDeveloper_linkText__JuPsI {
  color: var(--primary);
  text-decoration: underline;
  cursor: pointer;
}

.ShareDeveloper_messageLine__aTxEE {
  line-height: 1.6;
}

/* ============================= */
/* 📱 Extra Small Mobiles (<480px) */
/* ============================= */
@media (max-width: 480px) {
  .ShareDeveloper_container__NX6tL {
    flex-direction: column;
    padding: 0px;
  }
  .ShareDeveloper_shareDevWrap__4RodI {
    gap: 16px;
  }
  .ShareDeveloper_leftSection__L1fTW,
  .ShareDeveloper_rightSection__JZZ1S {
    width: 100%;
    padding: 16px;
    min-width: unset;
    border-right: 1px solid #ccc;
    border-radius: 10px;
  }

  .ShareDeveloper_title__ZMVnh {
    font-size: 1.4rem;
  }

  h3 {
    font-size: 1.1rem;
  }

  .ShareDeveloper_input__j0PCw {
         padding: 10px 12px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 4px;
  }

  .ShareDeveloper_button__OeutN {
    height: 40px;
    font-size: 14px;
  }

  .ShareDeveloper_messagePreview__NMXd9 {
    max-height: 200px;
  }
  .ShareDeveloper_appDetails__qgsWc {
    flex-direction: column;
    gap: 10px;
  }
  .ShareDeveloper_formGroup__p-dUP {
    width: 100%;
  }
  .ShareDeveloper_button__OeutN {
    margin-top: 0px;
    height: 50px;
  }
  .ShareDeveloper_appDetailsContent__RVxpu strong {
    padding: 0px;
    background: transparent;
    color: var(--primary-color);
    font-weight: 600;
    border: none;
  }
  .ShareDeveloper_appInfo__36n35 {
    padding: 16px;
  }
  .ShareDeveloper_inputIcon__7Cj-H {
    font-size: 16px;
  }
}

/* ============================= */
/* 📲 Small Mobiles (481px–767px) */
/* ============================= */
@media (min-width: 481px) and (max-width: 767px) {
  .ShareDeveloper_container__NX6tL {
    flex-direction: column;
  }
  .ShareDeveloper_shareDevWrap__4RodI {
    gap: 16px;
  }
  .ShareDeveloper_leftSection__L1fTW,
  .ShareDeveloper_rightSection__JZZ1S {
    width: 100%;
    padding: 25px;
    border-right: 1px solid #ccc;
    border-radius: 10px;
  }
  .ShareDeveloper_appDetails__qgsWc {
    flex-direction: column;
    gap: 10px;
  }
  .ShareDeveloper_formGroup__p-dUP {
    width: 100%;
  }
  .ShareDeveloper_button__OeutN {
    margin-top: 0px;
    height: 50px;
  }
  .ShareDeveloper_container__NX6tL {
    padding: 20px;
  }

  .ShareDeveloper_title__ZMVnh {
    font-size: 1.4rem;
  }
}

/* ============================= */
/* 💻 Tablets (768px–1023px) */
/* ============================= */
@media (min-width: 768px) and (max-width: 1023px) {
  /* .leftSection {
    flex: 1 1 45%;
  }

  .rightSection {
    flex: 1 1 50%;
    padding: 25px 30px;
  } */
  .ShareDeveloper_shareDevWrap__4RodI {
    gap: 16px;
  }
  .ShareDeveloper_leftSection__L1fTW,
  .ShareDeveloper_rightSection__JZZ1S {
    width: 100%;
    padding: 25px;
    border-right: 1px solid #ccc;
    border-radius: 10px;
  }
  .ShareDeveloper_formGroup__p-dUP {
    width: 100%;
  }
  .ShareDeveloper_button__OeutN {
    margin-top: 0px;
    height: 50px;
  }
  .ShareDeveloper_container__NX6tL {
    padding: 20px;
  }
  .ShareDeveloper_formWarp__VvS4Z {
    flex-direction: row;
    gap: 20px;
  }
}
@media (min-width: 1024px) and (max-width: 1186px) {
  .ShareDeveloper_shareDevWrap__4RodI {
    gap: 16px;
  }
  .ShareDeveloper_leftSection__L1fTW,
  .ShareDeveloper_rightSection__JZZ1S {
    width: 100%;
    padding: 25px;
    border-right: 1px solid #ccc;
    border-radius: 10px;
  }
  .ShareDeveloper_formGroup__p-dUP {
    width: 100%;
  }
}
/* ============================= */
/* 🖥️ Laptops / Desktops (1024px–1439px) */
/* ============================= */
@media (min-width: 1187px) and (max-width: 1439px) {
  .ShareDeveloper_leftSection__L1fTW {
    flex: 1 1 40%;
    /* height: 71vh; */
  }
  .ShareDeveloper_rightSection__JZZ1S {
    flex: 1 1 55%;
    /* height: 71vh; */
  }
  .ShareDeveloper_appDetails__qgsWc {
    flex-direction: column;
    gap: 10px;
    justify-content: space-between;
    border: 2px solid yellow;
  }
  /* .formWarp {
    flex-direction: row;
    gap: 20px;
  } */
  .ShareDeveloper_formWarp__VvS4Z .ShareDeveloper_formGroup__p-dUP {
    width: 100%;
  }
  .ShareDeveloper_button__OeutN {
    margin-top: 0px;
    height: 50px;
  }
}

/* ============================= */
/* 🖥️ Large Screens (1440px–2559px) */
/* ============================= */
@media (min-width: 1440px) and (max-width: 2559px) {
  .ShareDeveloper_appDetails__qgsWc {
    flex-direction: column;
    gap: 10px;
  }
  .ShareDeveloper_formGroup__p-dUP {
    width: 100%;
  }
  /* .rightSection {
    height: 76vh;
  } */
}

/* ============================= */
/* 📺 Ultra-wide / TV Displays (2560px+) */
/* ============================= */
@media (min-width: 2560px) {
  .ShareDeveloper_leftSection__L1fTW,
  .ShareDeveloper_rightSection__JZZ1S {
    padding: 60px;
    font-size: 1.4rem;
  }
  .ShareDeveloper_appDetailsContent__RVxpu strong {
    font-size: 1rem;
  }
  .ShareDeveloper_appDetailsContent__RVxpu p {
    font-size: 1rem;
  }
  /* h2 {
    font-size: 2.6rem;
  }

  h3 {
    font-size: 1.8rem;
  } */

  .ShareDeveloper_button__OeutN {
    height: 58px;
    font-size: 20px;
  }
  .ShareDeveloper_formGroup__p-dUP {
    width: 100%;
  }
  /* .rightSection {
    height: 78vh;
  } */
}
@media (min-width: 2872px) {
  .ShareDeveloper_rightSection__JZZ1S {
    height: -webkit-fill-available;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/ShareDeveloper/ShareDeveloper.module.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,aAAa;EACb,8CAA8C;EAC9C,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,8BAA8B;EAC9B,gDAAgD;EAChD,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6DAA6D;EAC7D,8BAA8B;EAC9B,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC,oCAAoC;AACpC,kCAAkC;AAClC;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;EACA;IACE,SAAS;EACX;EACA;;IAEE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,4BAA4B;IAC5B,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;SACO,kBAAkB;QACnB,eAAe;QACf,gBAAgB;QAChB,kBAAkB;EACxB;;EAEA;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,YAAY;IACZ,uBAAuB;IACvB,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC,mCAAmC;AACnC,kCAAkC;AAClC;EACE;IACE,sBAAsB;EACxB;EACA;IACE,SAAS;EACX;EACA;;IAEE,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,kCAAkC;AAClC,8BAA8B;AAC9B,kCAAkC;AAClC;EACE;;;;;;;KAOG;EACH;IACE,SAAS;EACX;EACA;;IAEE,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,YAAY;EACd;EACA;IACE,aAAa;EACf;EACA;IACE,mBAAmB;IACnB,SAAS;EACX;AACF;AACA;EACE;IACE,SAAS;EACX;EACA;;IAEE,WAAW;IACX,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;EACrB;EACA;IACE,WAAW;EACb;AACF;AACA,kCAAkC;AAClC,2CAA2C;AAC3C,kCAAkC;AAClC;EACE;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,SAAS;IACT,8BAA8B;IAC9B,wBAAwB;EAC1B;EACA;;;KAGG;EACH;IACE,WAAW;EACb;EACA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA,kCAAkC;AAClC,sCAAsC;AACtC,kCAAkC;AAClC;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;EACA;;KAEG;AACL;;AAEA,kCAAkC;AAClC,0CAA0C;AAC1C,kCAAkC;AAClC;EACE;;IAEE,aAAa;IACb,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;;;;;;KAMG;;EAEH;IACE,YAAY;IACZ,eAAe;EACjB;EACA;IACE,WAAW;EACb;EACA;;KAEG;AACL;AACA;EACE;IACE,8BAA8B;EAChC;AACF","sourcesContent":["/* 🌐 Base Layout */\n.container {\n  width: 100%;\n  /* background-color: var(--white-color); */\n  /* border-radius: 10px; */\n  padding: 2rem;\n  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */\n  height: 100%;\n  /* min-height: 0; */\n}\n.shareDevWrap {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  /* align-items: flex-start; */\n}\n.title {\n  font-size: 1.8rem;\n  font-weight: 600;\n  margin-bottom: 1.5rem;\n  color: var(--dark-color);\n  text-align: center;\n  letter-spacing: 0.5px;\n}\n.leftSection {\n  flex: 1 1 40%;\n  min-width: 360px;\n  background: #ffffffcc;\n  backdrop-filter: blur(10px);\n  border-radius: 6px 0px 0px 6px;\n  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); */\n  padding: 30px 40px;\n  border: 1px solid #ccc;\n  transition: all 0.3s ease;\n  /* height: 100%; */\n  border-right: 0px;\n}\n\n.rightSection {\n  flex: 1 1 55%;\n  min-width: 320px;\n  background: linear-gradient(135deg, #eff6ff 0%, #e0f2fe 100%);\n  border-radius: 0px 6px 6px 0px;\n  padding: 30px;\n  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08); */\n  /* height: 100%; */\n  border: 1px solid #ccc;\n  border-left: 2px dashed #a3a3fb;\n}\n\nh2 {\n  margin-bottom: 20px;\n  font-size: 1.8rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\nh3 {\n  margin-bottom: 15px;\n  font-size: 1.25rem;\n  color: #1e293b;\n}\n\n.appInfo {\n  background: #f1f5f9;\n  padding: 16px 20px;\n  border-radius: 12px;\n  margin-bottom: 25px;\n  border-left: 5px solid #3b82f6;\n}\n.appDetails {\n  display: flex;\n  align-items: flex-start;\n  gap: 30px;\n}\n.appDetailsContent {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.appDetailsContent strong {\n  font-weight: 500;\n  color: #111827;\n  margin-right: 4px;\n  background-color: var(--white-color);\n  border: 1px solid #2563eb;\n  padding: 8px 12px;\n  border-radius: 8px;\n  max-width: 75%;\n  word-wrap: break-word;\n  font-size: 16px;\n}\n.appDetailsContent p {\n  color: #475569;\n  text-align: left;\n}\n\n/* 📝 Form Styling */\n.form {\n  display: flex;\n  flex-direction: column;\n  /* gap: 18px; */\n}\n\n.formGroup {\n  margin-bottom: 24px;\n  position: relative;\n  text-align: left;\n}\n\n.label {\n  display: block;\n  margin-bottom: 10px;\n  font-size: 15px;\n  font-weight: 500;\n  color: #555;\n}\n\n.requiredStar {\n  color: red;\n  font-weight: bold;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input {\n  width: 100%;\n  padding: 16px;\n  font-weight: 600;\n  border: none;\n  background: var(--seconadry-ic-bg, #f9fafb);\n  border-radius: 8px;\n  color: var(--text-color, #111);\n  padding-right: 50px;\n  outline: none;\n}\n\n.inputIcon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-color, #666);\n  font-size: 24px;\n}\n\n.input:focus {\n  border-color: #3b82f6;\n  background: #fff;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n/* ℹ️ Help & Message Boxes */\n.helpText {\n  font-size: 12px;\n  color: #64748b;\n  margin-top: 10px;\n}\n\n.messagePreview {\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  padding: 15px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  line-height: 1.6;\n  white-space: pre-wrap;\n  /* max-height: 280px; */\n  overflow-y: auto;\n  color: #334155;\n  /* height: 93%; */\n  text-align: left;\n  border-left: 5px solid #3b82f6;\n}\n\n.messageLine {\n  margin-bottom: 18px;\n}\n\n.highlightedText {\n  color: #2563eb;\n  font-weight: 600;\n  background-color: #eff6ff;\n  padding: 1px 4px;\n  border-radius: 4px;\n}\n\n/* 🚀 Button */\n.button {\n  width: 100%;\n  height: 58px;\n  margin-top: 36px;\n  background-color: var(--primary);\n  color: var(--white-color);\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.button:hover:not(:disabled) {\n  background: var(--primary-hover);\n}\n\n.button:disabled {\n  background: #93c5fd;\n  cursor: not-allowed;\n}\n\n/* ✅ Status Messages */\n.status {\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-weight: 500;\n  text-align: center;\n}\n\n.success {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #bbf7d0;\n}\n\n.error {\n  background: #fee2e2;\n  color: #991b1b;\n  border: 1px solid #fecaca;\n}\n\n/* 🖼️ Right Panel Preview */\n.preview h3 {\n  margin-top: 0;\n  color: #0f172a;\n  font-weight: 600;\n}\n\n.previewList {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.previewList li {\n  padding: 8px 0;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  color: #334155;\n}\n\n.previewList li::before {\n  content: \"✔\";\n  margin-right: 8px;\n  color: var(--primary);\n}\n.formWarp {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n.linkText {\n  color: var(--primary);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.messageLine {\n  line-height: 1.6;\n}\n\n/* ============================= */\n/* 📱 Extra Small Mobiles (<480px) */\n/* ============================= */\n@media (max-width: 480px) {\n  .container {\n    flex-direction: column;\n    padding: 0px;\n  }\n  .shareDevWrap {\n    gap: 16px;\n  }\n  .leftSection,\n  .rightSection {\n    width: 100%;\n    padding: 16px;\n    min-width: unset;\n    border-right: 1px solid #ccc;\n    border-radius: 10px;\n  }\n\n  .title {\n    font-size: 1.4rem;\n  }\n\n  h3 {\n    font-size: 1.1rem;\n  }\n\n  .input {\n         padding: 10px 12px;\n        font-size: 14px;\n        font-weight: 500;\n        border-radius: 4px;\n  }\n\n  .button {\n    height: 40px;\n    font-size: 14px;\n  }\n\n  .messagePreview {\n    max-height: 200px;\n  }\n  .appDetails {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .formGroup {\n    width: 100%;\n  }\n  .button {\n    margin-top: 0px;\n    height: 50px;\n  }\n  .appDetailsContent strong {\n    padding: 0px;\n    background: transparent;\n    color: var(--primary-color);\n    font-weight: 600;\n    border: none;\n  }\n  .appInfo {\n    padding: 16px;\n  }\n  .inputIcon {\n    font-size: 16px;\n  }\n}\n\n/* ============================= */\n/* 📲 Small Mobiles (481px–767px) */\n/* ============================= */\n@media (min-width: 481px) and (max-width: 767px) {\n  .container {\n    flex-direction: column;\n  }\n  .shareDevWrap {\n    gap: 16px;\n  }\n  .leftSection,\n  .rightSection {\n    width: 100%;\n    padding: 25px;\n    border-right: 1px solid #ccc;\n    border-radius: 10px;\n  }\n  .appDetails {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .formGroup {\n    width: 100%;\n  }\n  .button {\n    margin-top: 0px;\n    height: 50px;\n  }\n  .container {\n    padding: 20px;\n  }\n\n  .title {\n    font-size: 1.4rem;\n  }\n}\n\n/* ============================= */\n/* 💻 Tablets (768px–1023px) */\n/* ============================= */\n@media (min-width: 768px) and (max-width: 1023px) {\n  /* .leftSection {\n    flex: 1 1 45%;\n  }\n\n  .rightSection {\n    flex: 1 1 50%;\n    padding: 25px 30px;\n  } */\n  .shareDevWrap {\n    gap: 16px;\n  }\n  .leftSection,\n  .rightSection {\n    width: 100%;\n    padding: 25px;\n    border-right: 1px solid #ccc;\n    border-radius: 10px;\n  }\n  .formGroup {\n    width: 100%;\n  }\n  .button {\n    margin-top: 0px;\n    height: 50px;\n  }\n  .container {\n    padding: 20px;\n  }\n  .formWarp {\n    flex-direction: row;\n    gap: 20px;\n  }\n}\n@media (min-width: 1024px) and (max-width: 1186px) {\n  .shareDevWrap {\n    gap: 16px;\n  }\n  .leftSection,\n  .rightSection {\n    width: 100%;\n    padding: 25px;\n    border-right: 1px solid #ccc;\n    border-radius: 10px;\n  }\n  .formGroup {\n    width: 100%;\n  }\n}\n/* ============================= */\n/* 🖥️ Laptops / Desktops (1024px–1439px) */\n/* ============================= */\n@media (min-width: 1187px) and (max-width: 1439px) {\n  .leftSection {\n    flex: 1 1 40%;\n    /* height: 71vh; */\n  }\n  .rightSection {\n    flex: 1 1 55%;\n    /* height: 71vh; */\n  }\n  .appDetails {\n    flex-direction: column;\n    gap: 10px;\n    justify-content: space-between;\n    border: 2px solid yellow;\n  }\n  /* .formWarp {\n    flex-direction: row;\n    gap: 20px;\n  } */\n  .formWarp .formGroup {\n    width: 100%;\n  }\n  .button {\n    margin-top: 0px;\n    height: 50px;\n  }\n}\n\n/* ============================= */\n/* 🖥️ Large Screens (1440px–2559px) */\n/* ============================= */\n@media (min-width: 1440px) and (max-width: 2559px) {\n  .appDetails {\n    flex-direction: column;\n    gap: 10px;\n  }\n  .formGroup {\n    width: 100%;\n  }\n  /* .rightSection {\n    height: 76vh;\n  } */\n}\n\n/* ============================= */\n/* 📺 Ultra-wide / TV Displays (2560px+) */\n/* ============================= */\n@media (min-width: 2560px) {\n  .leftSection,\n  .rightSection {\n    padding: 60px;\n    font-size: 1.4rem;\n  }\n  .appDetailsContent strong {\n    font-size: 1rem;\n  }\n  .appDetailsContent p {\n    font-size: 1rem;\n  }\n  /* h2 {\n    font-size: 2.6rem;\n  }\n\n  h3 {\n    font-size: 1.8rem;\n  } */\n\n  .button {\n    height: 58px;\n    font-size: 20px;\n  }\n  .formGroup {\n    width: 100%;\n  }\n  /* .rightSection {\n    height: 78vh;\n  } */\n}\n@media (min-width: 2872px) {\n  .rightSection {\n    height: -webkit-fill-available;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ShareDeveloper_container__NX6tL`,
	"shareDevWrap": `ShareDeveloper_shareDevWrap__4RodI`,
	"title": `ShareDeveloper_title__ZMVnh`,
	"leftSection": `ShareDeveloper_leftSection__L1fTW`,
	"rightSection": `ShareDeveloper_rightSection__JZZ1S`,
	"appInfo": `ShareDeveloper_appInfo__36n35`,
	"appDetails": `ShareDeveloper_appDetails__qgsWc`,
	"appDetailsContent": `ShareDeveloper_appDetailsContent__RVxpu`,
	"form": `ShareDeveloper_form__hr6Gk`,
	"formGroup": `ShareDeveloper_formGroup__p-dUP`,
	"label": `ShareDeveloper_label__K-pUx`,
	"requiredStar": `ShareDeveloper_requiredStar__VyZgF`,
	"inputWrapper": `ShareDeveloper_inputWrapper__i4RxL`,
	"input": `ShareDeveloper_input__j0PCw`,
	"inputIcon": `ShareDeveloper_inputIcon__7Cj-H`,
	"helpText": `ShareDeveloper_helpText__6oe+S`,
	"messagePreview": `ShareDeveloper_messagePreview__NMXd9`,
	"messageLine": `ShareDeveloper_messageLine__aTxEE`,
	"highlightedText": `ShareDeveloper_highlightedText__U8gOT`,
	"button": `ShareDeveloper_button__OeutN`,
	"status": `ShareDeveloper_status__YvP0O`,
	"success": `ShareDeveloper_success__96eqK`,
	"error": `ShareDeveloper_error__KBCVO`,
	"preview": `ShareDeveloper_preview__YePgf`,
	"previewList": `ShareDeveloper_previewList__yXXbp`,
	"formWarp": `ShareDeveloper_formWarp__VvS4Z`,
	"linkText": `ShareDeveloper_linkText__JuPsI`
};
export default ___CSS_LOADER_EXPORT___;
